!(function(win,doc){
    function setFontsize(){
        let winWidth = win.innerWidth;
        doc.documentElement.style.fontSize = (winWidth / 1920) * 100 + 'px';
    }
    setFontsize()
})(window,document)


// WEBPACK FOOTER //
// ./src/libs/auto-size.js